module.exports = __webpack_public_path__ + "static/media/yellow-in-german.51475696.jpg";